import { BETTERSTART_DIR } from '@cli-constants/paths.js'

export const BARREL_SCOPE = '_barrels'
export const REMOVED_SCOPE = '_removed'
export const UNSUPPORTED_PROJECT_STATE_MESSAGE =
  'Project state is unsupported or incomplete. Re-run `betterstart init --force` to create the current snapshot-backed layout.'
export const SNAPSHOT_COMMENT =
  '# BetterStart: snapshot files are local-only; manifest is committed'
export const SNAPSHOT_IGNORE = `${BETTERSTART_DIR}/`
export const SNAPSHOT_ATTRIBUTES = `${BETTERSTART_DIR}/** text eol=lf`
export const RENAME_MAX_EDIT_DISTANCE = 3
